import {
  formatAllowsMultipleDesigns,
  MAX_DESIGNS_PER_POST,
} from "@nlc/shared-types";

import type { PostType } from "../post-type-step/postTypes";
import type { DesignFile } from "./types";

import { isImageDesign } from "./isImageDesign";
import { isVideoDesign } from "./isVideoDesign";

export function designsProblem(
  designs: DesignFile[],
  postType: PostType,
): string | undefined {
  if (designs.length === 0) return "Choose a design to continue";
  if (designs.length > 1) {
    if (!formatAllowsMultipleDesigns(postType.format)) {
      return `A ${postType.label} can only have one design`;
    }
    if (designs.length > MAX_DESIGNS_PER_POST) {
      return `Pick up to ${MAX_DESIGNS_PER_POST} images`;
    }
    if (!designs.every((design) => isImageDesign(design))) {
      return "Posts with several designs can only have images";
    }
  }

  for (const design of designs) {
    const problem = designProblem(design, postType);

    if (problem) return problem;
  }
}

function designProblem(
  design: DesignFile,
  postType: PostType,
): string | undefined {
  const isVideo = isVideoDesign(design);

  if (!isVideo && !isImageDesign(design)) {
    return "Choose an image or video design";
  }
  if (postType.format === "reel" && !isVideo) {
    return "Reels need a video design";
  }
}
